import { useEffect, useState } from "react"
import { setAirportList, setBottomSticky, setCalenderFare, setSearchDataUser, setSearchFlights } from "../../redux/global/global.action";
import { get_all_airports, get_calendar_fare, search_flights_data, showAlertMessage } from "../server/api";
import { useDispatch,useSelector } from 'react-redux'
import {matchSorter} from 'match-sorter'
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import flightgif from '../../libs/gif/flight.gif'
import Loader from '../loader/Loader'

var Scroll = require('react-scroll');

// var Link      = Scroll.Link;
// var Button    = Scroll.Button;
// var Element   = Scroll.Element;
// var Events    = Scroll.Events;
var scroll    = Scroll.animateScroll;
// var scrollSpy = Scroll.scrollSpy;

const SearchModule = (props) => {
    const dispatch = useDispatch();
    const [multicityairports,setMulticityAirports] = useState([])
    const airport_list = useSelector(state => state.global.airport_list)
    const flight_token = useSelector(state => state.global.flight_token)
    const search_data = useSelector(state => state.global.search_data)
    
   
    const [segments,setSegments] = useState([
        {
            OriginName:'',
            DestinationName:'',
            Origin:'',
            Destination:'',
            FlightCabinClass:1,
            PreferredDepartureTime:new Date(),
            PreferredArrivalTime:new Date()
        }
    ])


    const [airports,setAirports] = useState([]);
    const [loadcircle,setLoadCircle] = useState(0)
    const [airports2,setAirports2] = useState([]);
    const [passengerdropdown,setPassengerDropdown] = useState(0);

    const setSearchData = (data) => {
        dispatch(setSearchDataUser({...data}))
    }
    //journeytype 1 - OneWay, 2 - Return, 3 - Multi Stop, 4 - AdvanceSearch, 5 - Special Return)

    // 1 for All, 2 for Economy, 3 for PremiumEconomy, 4 for Business, 5 for PremiumBusiness, 6 for First
    const handleChange = (e) => {
        dispatch(setBottomSticky(0))
        if(e.target.name === 'flight_from_name'){
            if(e.target.value.trim() == ''){
                setAirports([])
            }else{
                const arr = matchSorter(airport_list,e.target.value.trim(),{keys: ['name', 'code','city_name']})
                setAirports(arr)
            }
        }
        if(e.target.name === 'flight_to_name'){
            if(e.target.value.trim() == ''){
                setAirports2([])
            }else{
                const arr = matchSorter(airport_list,e.target.value.trim(),{keys: ['name', 'code','city_name']})
                setAirports2(arr)
            }
        }
        setSearchData({
        ...search_data,
        [e.target.name]: e.target.value.trim()
        });
    };

    const handleChange2 = (e,index) => {
        var mlairport = multicityairports;
        dispatch(setBottomSticky(0))

        if(e.target.name === 'flight_from_name'){
            if(e.target.value.trim() == ''){
                setAirports([])
                mlairport[index] = []
                setMulticityAirports(mlairport)
            }else{
                const arr = matchSorter(airport_list,e.target.value.trim(),{keys: ['name', 'code','city_name']})
                mlairport[index] = [...arr]
                setMulticityAirports(mlairport)
                setAirports(arr)
            }

            var seg = segments
            seg[index] = {
                ...seg[index],
                OriginName:e.target.value.trim()
            }
            setSegments(seg)
        }
        if(e.target.name === 'flight_to_name'){
            if(e.target.value.trim() == ''){
                setAirports2([])
                mlairport[index] = []
                setMulticityAirports(mlairport)
            }else{
                const arr2 = matchSorter(airport_list,e.target.value.trim(),{keys: ['name', 'code','city_name']})
                mlairport[index] = [...arr2]
                setMulticityAirports(mlairport)
                setAirports2(arr2)
            }

            var seg2 = segments
            seg2[index] = {
                ...seg2[index],
                DestinationName:e.target.value.trim()
            }
        }
        setSearchData({
        ...search_data,
        [e.target.name]: e.target.value.trim()
        });
    };

    const set_segment_status = (segment_no,obj) => {
        var seg = segments
            seg[segment_no] = {
                ...seg[segment_no],
                ...obj
            }
            setSegments(seg)
            setAirports([])
        setAirports2([])
        
    }

    const add_row = () => {
        const lengthc = segments.length;
        if(lengthc>0){
            const get_last_row = segments[lengthc-1];
            const { OriginName,
            DestinationName,
            Origin,
            Destination,
            FlightCabinClass,
            PreferredDepartureTime,
            PreferredArrivalTime} = get_last_row
            if(Origin==''){
                showAlertMessage('oops','Please select origin!',false,true)
            }else if(Destination == ''){
                showAlertMessage('oops','Please select destination',false,true)
            }
            else if(Origin === Destination){
                showAlertMessage('oops','Origin & Destination can\'t be same!',false,true)
            }else if(PreferredDepartureTime == ''){
                showAlertMessage('oops','Please select date!',false,true)

            }else{
                const new_Arr = [...segments];
                new_Arr.push({
                    OriginName:'',
                    DestinationName:'',
                    Origin:'',
                    Destination:'',
                    FlightCabinClass:1,
                    PreferredDepartureTime:new Date(),
                    PreferredArrivalTime:new Date()
                })
                setSegments(new_Arr)
            }
        }
    }

    const handleSelectAirport = async (name,code,type='from') => {
        if(type==='from'){
            setSearchData({
                ...search_data,
                flight_from_name:name,
                flight_from:code,
            })
        }else{
            setSearchData({
                ...search_data,
                flight_to_name:name,
                flight_to:code,
            })
        }
        setAirports([])
        setAirports2([])
    }

    const plus_minus_fun = (type='adult',inc='plus') => {
        if(type==='adult'){
            if(inc==='plus'){
                setSearchData({
                    ...search_data,
                    adultcount:search_data.adultcount+1
                })
            }else if(inc==='minus'){
                setSearchData({
                    ...search_data,
                    adultcount:search_data.adultcount<=0 ? 0 :search_data.adultcount-1
                })
            }

        }else if(type==='child'){
            if(inc==='plus'){
                setSearchData({
                    ...search_data,
                    childcount:search_data.childcount+1
                })
            }else if(inc==='minus'){
                setSearchData({
                    ...search_data,
                    childcount:search_data.childcount<=0 ? 0 :search_data.childcount-1
                })
            }

        }else if(type==='infant'){
            if(inc==='plus'){
                setSearchData({
                    ...search_data,
                    infantcount:search_data.infantcount+1
                })
            }else if(inc==='minus'){
                setSearchData({
                    ...search_data,
                    infantcount:search_data.infantcount<=0 ? 0 :search_data.infantcount-1
                })
            }

        }
    }

    const airport_list_update = () => {
        if(airport_list.length === 0){
            get_all_airports().then((rs)=>{
                if(rs.status){
                    dispatch(setAirportList(rs.data))
                }
            })
        }

    }


    const search_flights = () => {
        dispatch(setBottomSticky(0))
        const {departure_date,flight_from,flight_to,adultcount,journeyType,arrival_date} = search_data;

        if(departure_date=='' && journeyType != 3){
            showAlertMessage('oops','Please select departure date!',false,true)
        }else if(flight_from == '' && journeyType != 3){
            showAlertMessage('oops','Please select source',false,true)

        }else if(flight_to == '' && journeyType !=3){
            showAlertMessage('oops','Please select destination',false,true)

        }
        else if(flight_from === flight_to && journeyType !=3){
            showAlertMessage('oops','Origin & Destination can\'t be same!',false,true)

        }else if(adultcount == 0){
            showAlertMessage('oops','Please select adults!',false,true)
        }else if(journeyType==2 && arrival_date==''){
            showAlertMessage('oops','Please select arrival date!',false,true)

        }
        else{
            const new_arr = [];
            if(segments.length){
                for (let i = 0; i < segments.length; i++) {
                    const element = segments[i];
                    new_arr.push({
                        ...element,
                        PreferredArrivalTime: moment(element.PreferredArrivalTime).format('YYYY-MM-DD')+'T00: 00: 00',
                        PreferredDepartureTime: moment(element.PreferredDepartureTime).format('YYYY-MM-DD')+'T00: 00: 00',
                    })
                    
                }
            }
           

            const arr = {
                ...search_data,
                Segments:new_arr,
                departure_date: moment(search_data.departure_date).format('YYYY-MM-DD'),
                arrival_date: moment(search_data.arrival_date).format('YYYY-MM-DD')
            }

            setLoadCircle(1)
            search_flights_data(arr).then((res)=>{
                setLoadCircle(0);
                dispatch(setSearchFlights(res))
                if(res.status){
                    // scroller.scrollTo("", {
                    //     duration: 800,
                    //     delay: 0,
                    //     smooth: "easeInOutQuart",
                    // });
                    scroll.scrollTo(700);
                }else{
                    showAlertMessage('oops',res.message,false,true)
                }
            })
            
            if(journeyType != 3){
                const clndr_arr = {
                    ...arr,
                    arrival_date:moment(search_data.departure_date).format('YYYY-MM-DD')
                }
                get_calendar_fare(clndr_arr).then((res)=>{
                    dispatch(setCalenderFare(res))
                })
                .catch((err)=>{
                    console.log('=============error=======================');
                    console.log(err);
                    console.log('====================================');
                })
            }
           
        }

    }

    const set_journey_type = (type=1) => {
        // journeytype 1 - OneWay, 2 - Return, 3 - Multi Stop, 4 - AdvanceSearch, 5 - Special Return)
        setSearchData({
            ...search_data,
            journeyType:type
        })
    }

    useEffect(() => {
        airport_list_update();
        setSearchData({
            ...search_data,
            TokenId:flight_token.TokenId
        })
    }, [])

  

        return (
            <section class="breadcrumb-area bread-bg-6">
                {
                    loadcircle?<Loader/>:''
                }
                <div class="breadcrumb-wrap">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12">
                                <div class="search-result-content">
                                    <div class="section-heading">
                                        <h2 class="sec__title text-white">Flight Search Result</h2>
                                    </div>
                                    <div class="tab-content search-fields-container margin-top-30px" id="myTabContent">
                                    <div class="tab-pane fade show active" id="flight" role="tabpanel" aria-labelledby="flight-tab">
                                        <div class="section-tab section-tab-2 pb-3">
                                            <ul class="nav nav-tabs" id="myTab3" role="tablist">
                                                <li class="nav-item">
                                                    <div class={search_data.journeyType==1?'nav-link active':'nav-link'} onClick={()=>set_journey_type(1)} style={{cursor:"pointer"}} id="one-way-tab" data-toggle="tab" href="#one-way" role="tab" aria-controls="one-way" aria-selected="true">
                                                        One way
                                                    </div>
                                                </li>
                                                <li class="nav-item">
                                                    <div class={search_data.journeyType==2?'nav-link active':'nav-link'} onClick={()=>set_journey_type(2)} style={{cursor:"pointer"}} id="round-trip-tab" data-toggle="tab" href="#round-trip" role="tab" aria-controls="round-trip" aria-selected="false">
                                                        Round-trip
                                                    </div>
                                                </li>
                                                <li class="nav-item">
                                                    <div class={search_data.journeyType==3?'nav-link active':'nav-link'} onClick={()=>set_journey_type(3)} style={{cursor:"pointer"}} id="round-trip-tab" data-toggle="tab" href="#round-trip" role="tab" aria-controls="round-trip" aria-selected="false">
                                                        Multicity
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="tab-content" id="myTabContent3">
                                            <div class="tab-pane fade show active" id="one-way" role="tabpanel" aria-labelledby="one-way-tab">
                                                <div class="contact-form-action">
                                                    <form class="row align-items-center">
                                                        {
                                                            search_data.journeyType==3 ? (
                                                                <div className="col-lg-12">
                                                                    {
                                                                        segments.length ? 
                                                                        segments.map((res,index)=>{
                                                                            return (
                                                                                <div className="clone_obj row">
                                                                                    <div class="col-lg-4 pr-0">
                                                                                        <div class="input-box">
                                                                                            <label class="label-text">Flying from</label>
                                                                                            <div class="form-group">
                                                                                                <span class="la la-map-marker form-icon"></span>
                                                                                                <input class="form-control" autoComplete="off" onChange={(e)=>handleChange2(e,index)} type="text" value={res.OriginName} name="flight_from_name" placeholder="City or airport" />
                                                                                            </div>
                                                                                            <div class="inner show" role="listbox" id="bs-select-12" tabindex="-1" style={{overflowY: 'auto',display:airports.length?'block':'none'}}>
                                                                                                <ul class="dropdown-menu inner show" role="presentation" style={{marginTop:0,marginBottom:0}}>
                                                                                                    {
                                                                                                        multicityairports[index] ?  
                                                                                                        multicityairports[index].map((data)=>{
                                                                                                            return (
                                                                                                                <li key={data.id} onClick={()=>set_segment_status(index,{OriginName:data.name+' '+data.city_name.trim(),Origin:data.code})} style={{cursor:'pointer'}} class="dropdown-item"><span class="text">{data.name?data.name+', ':''} {data.city_name}</span></li>
                                                                                                            );
                                                                                                        })
                                                                                                        : ''
                                                                                                    }
                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-4">
                                                                                        <div class="input-box">
                                                                                            <label class="label-text">Flying to</label>
                                                                                            <div class="form-group">
                                                                                                <span class="la la-map-marker form-icon"></span>
                                                                                                <input class="form-control" autoComplete="off" onChange={(e)=>handleChange2(e,index)} name="flight_to_name" value={res.DestinationName} type="text" placeholder="City or airport" />
                                                                                            </div>
                                                                                            <div class="inner show" role="listbox" id="bs-select-12" tabindex="-1" style={{overflowY: 'auto',display:airports2.length?'block':'none'}}>
                                                                                                <ul class="dropdown-menu inner show" role="presentation" style={{marginTop:0,marginBottom:0}}>
                                                                                                    {
                                                                                                        multicityairports[index] ?  
                                                                                                        multicityairports[index].map((data)=>{
                                                                                                            return (
                                                                                                                <li key={data.id} onClick={()=>set_segment_status(index,{DestinationName:data.name+' '+data.city_name.trim(),Destination:data.code})} style={{cursor:'pointer'}} class="dropdown-item"><span class="text">{data.name?data.name+', ':''} {data.city_name}</span></li>
                                                                                                            );
                                                                                                        })
                                                                                                        : ''
                                                                                                    }
                                                                                                </ul>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-4">
                                                                                        <div class="input-box">
                                                                                            <label class="label-text">Departure</label>
                                                                                            <div class="form-group">
                                                                                                <span class="la la-calendar form-icon"></span>
                                                                                                <DatePicker className="date-range form-control"
                                                                                                minDate={moment().toDate()}
                                                                                                placeholderText="Select Departure Date"
                                                                                                selected={res.PreferredDepartureTime} onChange={(date) => set_segment_status(
                                                                                                    index,
                                                                                                    {
                                                                                                        PreferredArrivalTime:date,
                                                                                                        PreferredDepartureTime:date
                                                                                                    }
                                                                                                )}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                )
                                                                        })

                                                                        :''
                                                                    }
                                                                    {/* <div className="row" > */}
                                                                        <div class="col-lg-3 pr-0">
                                                                            <div class="form-group">
                                                                                <button class="theme-btn add-flight-btn margin-top-40px w-100" onClick={add_row}  type="button"><i class="la la-plus mr-1"></i>Add flight</button>
                                                                            </div>
                                                                        </div>
                                                                    {/* </div> */}
                                                                </div>
                                                            ) 
                                                            :
                                                        (
                                                        <>
                                                        <div class="col-lg-6 pr-0">
                                                            <div class="input-box">
                                                                <label class="label-text">Flying from</label>
                                                                <div class="form-group">
                                                                    <span class="la la-map-marker form-icon"></span>
                                                                    <input class="form-control" autoComplete="off" onChange={handleChange} type="text" value={search_data.flight_from_name} name="flight_from_name" placeholder="City or airport" />
                                                                </div>
                                                                <div class="inner show" role="listbox" id="bs-select-12" tabindex="-1" style={{overflowY: 'auto',display:airports.length?'block':'none'}}>
                                                                    <ul class="dropdown-menu inner show" role="presentation" style={{marginTop:0,marginBottom:0}}>
                                                                        {
                                                                            airports ?  
                                                                            airports.map((data)=>{
                                                                                return (
                                                                                    <li key={data.id} onClick={()=>handleSelectAirport(data.name+' '+data.city_name.trim(),data.code,'from')} style={{cursor:'pointer'}} class="dropdown-item"><span class="text">{data.name?data.name+', ':''} {data.city_name}</span></li>
                                                                                );
                                                                            })
                                                                            : ''
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <div class="input-box">
                                                                <label class="label-text">Flying to</label>
                                                                <div class="form-group">
                                                                    <span class="la la-map-marker form-icon"></span>
                                                                    <input class="form-control" autoComplete="off" onChange={handleChange} name="flight_to_name" value={search_data.flight_to_name} type="text" placeholder="City or airport" />
                                                                </div>
                                                                <div class="inner show" role="listbox" id="bs-select-12" tabindex="-1" style={{overflowY: 'auto',display:airports2.length?'block':'none'}}>
                                                                    <ul class="dropdown-menu inner show" role="presentation" style={{marginTop:0,marginBottom:0}}>
                                                                        {
                                                                            airports2 ?  
                                                                            airports2.map((data)=>{
                                                                                return (
                                                                                    <li key={data.id} onClick={()=>handleSelectAirport(data.name+' '+data.city_name.trim(),data.code,'to')} style={{cursor:'pointer'}} class="dropdown-item"><span class="text">{data.name?data.name+', ':''} {data.city_name}</span></li>
                                                                                );
                                                                            })
                                                                            : ''
                                                                        }
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 pr-0">
                                                            <div class="input-box">
                                                                <label class="label-text">Departure</label>
                                                                <div class="form-group">
                                                                    <span class="la la-calendar form-icon"></span>
                                                                    <DatePicker className="date-range form-control"
                                                                    minDate={moment().toDate()}
                                                                    placeholderText="Select Departure Date"
                                                                    selected={search_data.departure_date} onChange={(date) => setSearchData(
                                                                        {
                                                                            ...search_data,
                                                                            departure_date:date
                                                                        }
                                                                    )}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </>
                                                        )
                                                        }

                                                        {
                                                            search_data.journeyType==2 ? 
                                                            <div class="col-lg-3 pr-0">
                                                                <div class="input-box">
                                                                    <label class="label-text">Return</label>
                                                                    <div class="form-group">
                                                                        <span class="la la-calendar form-icon"></span>
                                                                        <DatePicker className="date-range form-control"
                                                                        minDate={moment(search_data.departure_date).toDate()}
                                                                        placeholderText="Select Arrival Date"
                                                                        selected={search_data.arrival_date} onChange={(date) => setSearchData(
                                                                            {
                                                                                ...search_data,
                                                                                arrival_date:date
                                                                            }
                                                                        )}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ''
                                                        }
                                                       
                                                        <div class="col-lg-3 pr-0">
                                                            <div class="input-box">
                                                                <label class="label-text">Passengers</label>
                                                                <div class="form-group">
                                                                    <div class="dropdown dropdown-contain gty-container">
                                                                        <div class="dropdown-toggle dropdown-btn" style={{cursor:"pointer"}} role="button" data-toggle="dropdown" aria-expanded="false" onClick={()=>setPassengerDropdown(!passengerdropdown)} >
                                                                            <span class="adult" data-text="Adult" data-text-multi="Adults">{search_data.adultcount} Adult</span>
                                                                            -
                                                                            <span class="children" data-text="Child" data-text-multi="Children">{search_data.childcount} Child</span>
                                                                        </div>
                                                                        <div class="dropdown-menu dropdown-menu-wrap" style={{display:passengerdropdown?'block':'none'}} >
                                                                            <div class="dropdown-item">
                                                                                <div class="qty-box d-flex align-items-center justify-content-between">
                                                                                    <label>Adults</label>
                                                                                    <div class="qtyBtn d-flex align-items-center">
                                                                                        <div class="qtyDec"   onClick={()=>plus_minus_fun('adult','minus')}><i class="la la-minus"></i></div>
                                                                                        <input type="text" name="adultcount" value={search_data.adultcount} />
                                                                                        <div class="qtyInc" onClick={()=>plus_minus_fun('adult','plus')}  ><i class="la la-plus"></i></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="dropdown-item">
                                                                                <div class="qty-box d-flex align-items-center justify-content-between">
                                                                                    <label>Children</label>
                                                                                    <div class="qtyBtn d-flex align-items-center">
                                                                                        <div class="qtyDec" onClick={()=>plus_minus_fun('child','minus')} ><i class="la la-minus"></i></div>
                                                                                        <input type="text" name="childcount" value={search_data.childcount} />
                                                                                        <div class="qtyInc" onClick={()=>plus_minus_fun('child','plus')} ><i class="la la-plus"></i></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="dropdown-item">
                                                                                <div class="qty-box d-flex align-items-center justify-content-between">
                                                                                    <label>Infants</label>
                                                                                    <div class="qtyBtn d-flex align-items-center">
                                                                                        <div class="qtyDec" onClick={()=>plus_minus_fun('infant','minus')} ><i class="la la-minus"></i></div>
                                                                                        <input type="text" name="infantcount" value={search_data.infantcount} class="qty-input" />
                                                                                        <div class="qtyInc" onClick={()=>plus_minus_fun('infant','plus')} ><i class="la la-plus"></i></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 pr-0">
                                                            <div class="input-box">
                                                                <label class="label-text">Class</label>
                                                                <div class="form-group select-contain w-auto">
                                                                    <div class="dropdown bootstrap-select select-contain-select ">
                                                                        <select class="select-contain-select" tabindex="-98">
                                                                            <option value="1" selected>All</option>
                                                                            <option value="2" >Economy</option>
                                                                            <option value="3" >Premium Economy</option>
                                                                            <option value="4">Business</option>
                                                                            <option value="5">Premium Business</option>
                                                                            <option value="6">First class</option>
                                                                        </select>
                                                                        <button type="button" class="btn dropdown-toggle btn-light" data-toggle="dropdown" role="combobox" aria-owns="bs-select-1" aria-haspopup="listbox" aria-expanded="true" title="Economy"><div class="filter-option"><div class="filter-option-inner"><div class="filter-option-inner-inner">All</div></div> </div></button>
                                                                    <div class="dropdown-menu "><div class="bs-searchbox"><input type="search" class="form-control" autocomplete="off" placeholder="Search" role="combobox" aria-label="Search" aria-controls="bs-select-1" aria-autocomplete="list" /></div><div class="inner show" role="listbox" id="bs-select-1" tabindex="-1"><ul class="dropdown-menu inner show" role="presentation"></ul></div></div></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <button type="button" onClick={search_flights} class="theme-btn w-100 text-center margin-top-20px">Search Now</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                   
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bread-svg-box">
                    <svg class="bread-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none"><polygon points="100 0 50 10 0 0 0 10 100 10"></polygon></svg>
                </div>
            </section>
    )
    
}

export default SearchModule